export default __webpack_public_path__ + "static/media/tvs-client.c1bc10b6.webp";